import { render } from "./MenuIndex.vue?vue&type=template&id=d51645c6"
import script from "./MenuIndex.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuIndex.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/Menu/MenuIndex.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "d51645c6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('d51645c6', __exports__)) {
    api.reload('d51645c6', __exports__)
  }
  
  module.hot.accept("./MenuIndex.vue?vue&type=template&id=d51645c6", () => {
    api.rerender('d51645c6', render)
  })

}


export default __exports__